module.exports = __webpack_public_path__ + "img/cancel-icon.6184c2db.svg";